import { useEffect } from 'react';

export const useLanguageRedirect = () => {
  useEffect(() => {
    const checkLanguageAndRedirect = () => {
      const hostname = window.location.hostname;
      
      // Ignora localhost e desenvolvimento
      if (hostname === 'localhost' || hostname.includes('lovable')) {
        return;
      }

      // Detecta o idioma do navegador
      const browserLanguage = navigator.language.toLowerCase();
      const isPtBr = browserLanguage.startsWith('pt-br') || browserLanguage === 'pt';
      
      const isOnBrazilianDomain = hostname.includes('arvorenota10.com.br');
      const isOnInternationalDomain = hostname.includes('treerated10.com');

      // Se estamos no domínio correto, limpar flag e retornar
      if ((isPtBr && isOnBrazilianDomain) || (!isPtBr && isOnInternationalDomain)) {
        sessionStorage.removeItem('language_redirect_attempted');
        return;
      }

      // Verificar se já tentamos redirecionar (proteção contra loop)
      if (sessionStorage.getItem('language_redirect_attempted')) {
        console.log('Redirect already attempted, skipping to prevent loop');
        return;
      }

      // Usuário com pt-br acessando domínio internacional
      if (isPtBr && isOnInternationalDomain) {
        sessionStorage.setItem('language_redirect_attempted', 'true');
        window.location.replace('https://arvorenota10.com.br' + window.location.pathname);
        return;
      }

      // Usuário sem pt-br acessando domínio brasileiro
      if (!isPtBr && isOnBrazilianDomain) {
        sessionStorage.setItem('language_redirect_attempted', 'true');
        window.location.replace('https://treerated10.com' + window.location.pathname);
        return;
      }
    };

    checkLanguageAndRedirect();
  }, []);
};
